import { useAuthStore } from '../store/authStore';

const VITE_BASE = import.meta.env.VITE_API_URL || 'http://localhost:5001';
const API_BASE = `${VITE_BASE}/api`;

export interface BroadcastResponse {
    success: boolean;
    message: string;
}

export async function triggerWeatherBroadcast(): Promise<BroadcastResponse> {
    const { accessToken } = useAuthStore.getState();

    const response = await fetch(`${API_BASE}/weather-broadcast/trigger`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken || ''}`,
        },
    });

    const data = await response.json();

    if (!response.ok) {
        throw new Error(data.message || 'Failed to trigger weather broadcast');
    }

    return data as BroadcastResponse;
}
